import React from "react";
import Swal from "sweetalert2";

export default function ConfirmButton({ orderId, onConfirm }) {
  const handleConfirmClick = () => {
    Swal.fire({
      title: `<h4>Are you sure you want to confirm this order?</h4>`,
      text: "Once confirmed, this action cannot be reverted!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, confirm it!",
      customClass: {
        title: "swal-custom-title",
        icon: "swal-custom-icon",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm(orderId);
      }
    });
  };

  return (
    <button
      className="confirm-button btn btn-success mt-5"
      onClick={(e) => {
        e.preventDefault(); 
        handleConfirmClick();
      }}
    >
      CONFIRM
    </button>
  );
}
